// extracted by mini-css-extract-plugin
module.exports = {"th":"AccountLinkTooltip_th__PxLql","banReason":"AccountLinkTooltip_banReason__3_t92"};